import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { getStripeCustomerPortalUrl, getStripeSessionId, getSubscriptionPortalPackages } from "../services/stripe";

export const customerPortalUrlQueryOptions = (...args: Parameters<typeof getStripeCustomerPortalUrl>) =>
    queryOptions({
        queryKey: ['customerPortalURL'],
        queryFn: async () => {
            const data = await getStripeCustomerPortalUrl(...args);
            return data.data;
        },
    })

export const useStripeSessionIdQuery = () => {
    return useQuery({
        queryKey: ['stripeSessionId'],
        queryFn: async () => {
            const data = await getStripeSessionId();
            return data.data;
        },
    })
}

export const useSubscriptionPackages = () => {
    return useQuery({
        queryKey: ['stripeSessionId'],
        queryFn: async () => {
            const data = await getSubscriptionPortalPackages();
            return data.data.data;
        },
    })
}

export const LIGHT_PRODUCT_CODE = "light";
export const PROFESSIONEL_PRODUCT_CODE = "professional";
export const useMutationStripePortalUrl = (productCode: string) => {
    return useMutation({
        mutationKey: ['customerPortalURL', productCode],
        mutationFn: async () => {
            const { data } = await getStripeCustomerPortalUrl(productCode);
            const url = data?.data?.result
            if (url) {
                window.open(url, "_self")
            }
            return url
        },
    })
}
